import {
  ContentLoader,
  EmailField,
  Heading,
  PrimaryButton,
  useForm,
} from '@weave/design-system';
import { theme } from '@weave/theme';
import { FC } from 'react';
import { useSendUserInviteEmail } from '../onboarding.queries';
import { useSelector } from 'react-redux';
import { selectCurrentLocationId } from 'redux/actions/location';
import { useAlert } from '@weave/alert-system';
import { getParsedErrorMessage } from 'redux/axios';

export const SendUserInviteEmailAction: FC = () => {
  const locationId = useSelector(selectCurrentLocationId);
  const alert = useAlert();

  const {
    formProps,
    values: formValues,
    getFieldProps,
    isComplete,
    reset,
  } = useForm({
    fields: {
      email: { type: 'email' },
    },
    onSubmit: ({ email }) => {
      sendUserInviteEmail({
        emailAddress: email,
        locationId,
      });
    },
  });

  const { mutate: sendUserInviteEmail, isLoading: isMutating } = useSendUserInviteEmail({
    onSuccess: () => {
      alert.success('Invite link sent successfully');
      reset();
    },
    onError: (error) => {
      const parsedError = getParsedErrorMessage(error);
      alert.error('Failed to send invite link: ' + parsedError);
      console.error(getParsedErrorMessage(error));
    },
  });

  return (
    <form
      css={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(1) }}
      {...formProps}
    >
      <ContentLoader show={isMutating} />
      <Heading level={3}>Send account creation link to email</Heading>
      <div css={{ display: 'flex', gap: theme.spacing(2) }}>
        <EmailField
          label="Email Address"
          placeholder="Enter email address"
          {...getFieldProps('email')}
          css={{ minWidth: 300 }}
        />
        <PrimaryButton
          disabled={!isComplete || !formValues.email || isMutating}
          type="submit"
          css={{ maxWidth: 'max-content' }}
        >
          Send Email Invite
        </PrimaryButton>
      </div>
    </form>
  );
};
